function formatMoney(cents, format = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
    formatString = format || '€{{amount_with_comma_separator}} EUR';
  function defaultTo(value2, defaultValue) {
    return value2 == null || value2 !== value2 ? defaultValue : value2;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ",");
    decimal = defaultTo(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    let parts = number.split("."),
      dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        "$1" + thousands
      ),
      centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }
  let value = "";
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 0, "'");
      break;
  }
  if (formatString.indexOf("with_comma_separator") !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
}

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

var MiniShippingEstimator = class extends HTMLElement {
  connectedCallback() {
    this.select = this.querySelector('.country-select');
    var selectedVal = getCookie('MiniShippingEstimator')
      ? getCookie('MiniShippingEstimator')
      : 'Germany';
    this.select.value = selectedVal;
    this.select.addEventListener('change', this._estimateShipping.bind(this));

    this._estimateShipping();
  }
  async _estimateShipping() {
    const shippingCountryArray = JSON.parse(
      this.querySelector('#country-with-province-zip').innerHTML
    );
    const selectedShippingCountryName = this.select.value;

    setCookie('MiniShippingEstimator', selectedShippingCountryName, 3);
    const selectedShippingCountry = shippingCountryArray.find(
      shippingCountry => {
        return shippingCountry['country'] == selectedShippingCountryName;
      }
    );

    const zip = selectedShippingCountry['zip'],
      country = selectedShippingCountry['country'],
      province = selectedShippingCountry['province'];

    console.log(zip, country, province);

    this.querySelector('.country__shipping-value').innerHTML =
      `<div class="spinner"><svg focusable="false" width="24" height="24" class="icon icon--spinner" viewBox="25 25 50 50"><circle cx="50" cy="50" r="20" fill="none" stroke="currentColor" stroke-width="5"></circle></svg>`;

    this.querySelector('.shipping-estimate-error').style.display = 'none';
    this.querySelector('.shipping-estimate-error').innerHTML = '';

    const prepareResponse = await fetch(
      `${shopUrl}/cart/prepare_shipping_rates.json?shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${province}`,
      { method: 'POST' }
    );
    if (prepareResponse.ok) {
      const shippingRates = await this._getAsyncShippingRates(
        zip,
        country,
        province
      );
      this._formatShippingRates(shippingRates);
    } else {
      const jsonError = await prepareResponse.json();
      this._formatError(jsonError);
    }
  }
  async _getAsyncShippingRates(zip, country, province) {
    const response = await fetch(
      `${shopUrl}/cart/async_shipping_rates.json?shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${province}`
    );
    const responseAsText = await response.text();
    if (responseAsText === 'null') {
      return this._getAsyncShippingRates(zip, country, province);
    } else {
      return JSON.parse(responseAsText)['shipping_rates'];
    }
  }
  _formatShippingRates(shippingRates) {
    console.log(shippingRates);
    const cartTotalPrice = parseFloat(this.select.dataset.cartTotal);

    if (shippingRates.length === 0) {
      this.querySelector('.country__shipping-value').innerHTML = `${formatMoney(
        parseFloat(0.0) * 100
      )}`;

      this.querySelector('.shipping-estimate-error').style.display = 'block';
      this.querySelector('.shipping-estimate-error').innerHTML =
        'Entschuldige, wir liefern leider niche an Deine Adresse.';

      document.querySelector('.total-value-price').innerHTML = `${formatMoney(
        cartTotalPrice
      )}`;

      return;
    }

    const shippingRatePrice = parseFloat(shippingRates[0]['price'] * 100);

    if (shippingRatePrice == 0) {
      this.querySelector('.country__shipping-value').innerHTML =
        `<span class="free-shipping-label">Kostenlos</span>`;
    } else {
      this.querySelector('.country__shipping-value').innerHTML = `${formatMoney(
        shippingRatePrice
      )}`;
    }

    document.querySelector('.total-value-price').innerHTML = `${formatMoney(
      cartTotalPrice + shippingRatePrice
    )}`;
  }
  _formatError(errors) {
    console.log(errors);
  }
};

window.customElements.define('mini-shipping-estimator', MiniShippingEstimator);
